export default __webpack_public_path__ + "static/media/get-paid.620baffc.mp4";